import React from "react";
import { useEffect, useState, useRef } from "react";
import NavButton from "../../homepage/header-banner/TopNavButton";
import Kafka from "../../homepage/header-banner/Kafka";
import Footer from "../../homepage/footer/Footer";
import Cloudconsult from "../../homepage/consult/cloudconsult";
import Banner from "../../container/Banner/Banner";
import { Container, Row, Col } from "react-bootstrap";
import Sidebar from "../../container/Sidebar/Sidebar";
import "../../container/Sidebar/sidebar.css";
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute";
import Contentcloudcard from "../../container/Card/Components/Contentcloudcard";
import Imagecloudcompute from "../../container/Card/Components/Imagecloudcompute";
import CardBox from "../../container/Box/Components/CardBox";
import CloudConsultCp from "../../homepage/consult/cloudconsult-cp";
import "../../Style/typo.css";
import Cloudconsult2 from "../../homepage/consult/cloudconsult-2";
import BannerPrivateCloud from "../../container/Banner/banner-privateCloud";
import DividerComponent from "../../container/Divider/divider";
import styled from "styled-components";
import useIsMobile from "../../container/Sidebar/useIsMobile";
import BannerPrivateCloudVN from "../../container/Banner/banner-privateCloud-vn";
import Cloudconsult2VN from "../../homepage/consult/cloudconsult-2-vn";
import SidebarVN from "../../container/Sidebar/Sidebar-vn";
import HeaderVn from "../../detailpageVN/Page/component/headervn";
import FooterVn from "../../detailpageVN/Page/component/footervn";

const Sysfont = styled.div`
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
`;

function ClusterkafkaVN() {
    const isMobile = useIsMobile();
    useEffect(() => {
        document.title = "Private Kafka Cluster - Private Kubernetes - Private Cloud";
    }, []);
    return (
        <Sysfont className="App">
            <HeaderVn />
            <BannerPrivateCloudVN />
            <Container className="main-body">
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <SidebarVN />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("Kubernetes for Kafka Engine")} */}
                        {/* {Contentcloudcard("모든 컨테이너(POD) 고용량 SSD 디스크 제공, 고용량의 메모리 할당")} */}
                        <MuiGrid container spacing={3}>
                            <MuiGrid item xs={12} sm={12}>
                                {CardBox(
                                    "<p class='typo-21-sm typo-medium typo-black'>Nền tảng xử lý dữ liệu và sự kiện theo thời gian thực trên đám mây</p>",
                                    `<p class='typo-14'>Nền tảng stream dữ liệu sử dụng Kafka, được triển khai trên môi trường Kubernetes.</p>
                                <p class='typo-14'>Hệ thống hỗ trợ kết nối linh hoạt với nhiều máy chủ ảo (instance) thuộc nền tảng đám mây Hanbiro.</p>`,
                                )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12}>
                                {CardBox(
                                    "<p class='typo-21-sm typo-medium typo-black'>Nền tảng stream dữ liệu hỗ trợ sharding và replica trong Kubernetes</p>",
                                    `<p class='typo-14'>Khi container (POD) gặp sự cố, hệ thống vẫn duy trì dịch vụ nhờ container dự phòng. </p>
                                <p class='typo-14'>Kafka hỗ trợ sharding để mở rộng theo chiều ngang và lưu trữ dữ liệu phân tán qua các topic trên nhiều container.</p>
                                <p class='typo-14'>Công cụ stream thời gian thực hoạt động ổn định nhờ tích hợp sâu trong phần mềm của Hanbiro.</p>`,
                                )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12}>
                                {CardBox(
                                    "<p class='typo-21-sm typo-medium typo-black'>Quản lý volume persistent hiệu suất cao, tối ưu truy xuất dữ liệu</p>",
                                    `<p class='typo-14'>Dữ liệu được lưu trữ trên SSD và triển khai thông qua 3 replica container cho mỗi dịch vụ.</p>
                                <p class='typo-14'>Khi một node phần cứng trong Kubernetes bị lỗi, replica container sẽ tiếp nhận và duy trì hoạt động của dịch vụ mà không gây gián đoạn.</p>`,
                                )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12}>
                                {CardBox(
                                    "<p class='typo-21-sm typo-medium typo-black'>Tự động di chuyển container (POD) khi gặp sự cố phần cứng, đảm bảo hệ thống vận hành liên tục</p>",
                                    `<p class='typo-14'>Container Elasticsearch sử dụng 3 bản sao (replica POD) cho từng dịch vụ.</p>
                                <p class='typo-14'>Các replica này được phân bổ trên nhiều node worker trong hệ thống Kubernetes, giúp dịch vụ luôn duy trì ổn định dù có sự cố hạ tầng xảy ra.</p>`,
                                )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12}>
                                {CardBox(
                                    "<p class='typo-21-sm typo-medium typo-black'>Tự động mở rộng container và phân bổ tài nguyên tối ưu</p>",
                                    `<p class='typo-14'>Số lượng container (POD) được tự động điều chỉnh linh hoạt dựa trên mức sử dụng CPU, bộ nhớ hoặc hành vi của người dùng.</p>
                                <p class='typo-14'>Hệ thống có khả năng mở rộng bằng cách bổ sung tài nguyên phần cứng khi cần và cho phép cấu hình lại dịch vụ một cách linh hoạt.</p>
                                <p class='typo-14'>Đây là giải pháp cluster giúp cân bằng tải hiệu quả và tối ưu chi phí vận hành.</p>`,
                                )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12}>
                                {Imagecloudcompute("https://hanbiro.com/cloud/library/cluster-kafka/kafka_cluster.svg")}
                            </MuiGrid>
                            <DividerComponent />
                        </MuiGrid>

                        {/* <Kafka /> */}
                        <Cloudconsult2VN />
                    </Col>
                </Row>
            </Container>

            <FooterVn />
        </Sysfont>
    );
}

const MuiGrid = styled.div`
    padding: 0px;
`;

export default ClusterkafkaVN;
